module.exports = __webpack_public_path__ + "static/media/Logo.c90ad034.svg";